"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.access.denied.title': 'Dostęp zabroniony',
    'reports.access.denied.enterprise': 'Użytkownicy przedsiębiorstw nie mają dostępu do raportów kosztów.',
    'reports.access.denied.general': 'Tylko użytkownicy nadrzędni i super administratorzy mogą uzyskać dostęp do raportów kosztów.',
};
